const WORKY_TIME_PICKER_V3_DISPLAY_SIZE = {
  DEFAULT: 'default',
  COMPACT: 'compact',
} as const;

type WorkyTimePickerV3DisplaySize =
  (typeof WORKY_TIME_PICKER_V3_DISPLAY_SIZE)[keyof typeof WORKY_TIME_PICKER_V3_DISPLAY_SIZE];

const WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME = {
  ROOT: 'timepickerv4--compact',
  INPUT: 'time-input--compact',
  AMPM_HOLDER: 'ampm-button-holder--compact',
} as const;

const WORKY_TIME_PICKER_V3_COMPACT_DISPLAY_CONFIG: Readonly<{
  readonly size: typeof WORKY_TIME_PICKER_V3_DISPLAY_SIZE.COMPACT;
}> = {
  size: WORKY_TIME_PICKER_V3_DISPLAY_SIZE.COMPACT,
};

export type { WorkyTimePickerV3DisplaySize };

export {
  WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME,
  WORKY_TIME_PICKER_V3_COMPACT_DISPLAY_CONFIG,
  WORKY_TIME_PICKER_V3_DISPLAY_SIZE,
};
